export default {
  head_title: {
    app: 'Last-Mile Dashboard',
    payable_payment_request: 'Payment Requests | Last-Mile Dashboard',
    payable_shipper: 'Shipper Payables | Last-Mile Dashboard',
    payable_transporter_dedicated: 'Dedicated Transporter Payables | Last-Mile Dashboard',
    payable_transporter_oncall: 'On Call Transporter Payables | Last-Mile Dashboard',
    receivable_fleets: 'Fleet Receivables | Last-Mile Dashboard',
    receivable_invoices: 'Invoices | Last-Mile Dashboard',
    receivable_shipments: 'Delivery Order Receivables | Last-Mile Dashboard',
    shipment: 'Shipments | Last-Mile Dashboard',
    shipment_allocation: 'Shipment Allocations | Last-Mile Dashboard',
    shipment_dispatch: 'Shipment Dispatches | Last-Mile Dashboard',
    shipment_monitoring: 'Shipment Monitorings | Last-Mile Dashboard',
    shipment_routing: 'Shipment Routings | Last-Mile Dashboard',
    shipment_x: 'Shipment - {{x}} | Last-Mile Dashboard',
    shipment_x_customer: 'Shipment Customer - {{x}} | Last-Mile Dashboard',
    shipment_x_document: 'Shipment Documents - {{x}} | Last-Mile Dashboard',
    shipment_x_pricing: 'Shipment Pricing - {{x}} | Last-Mile Dashboard',
    shipment_x_shipment: 'Shipment Detail - {{x}} | Last-Mile Dashboard',
    shipper: 'Shippers | Last-Mile Dashboard',
    shipper_location: 'Shipper Locations | Last-Mile Dashboard',
    shipper_projects: 'Shipper Projects | Last-Mile Dashboard',
    shipper_x_location: 'Shipper Locations - {{x}} | Last-Mile Dashboard',
    shipper_x_projects: 'Shipper Projects - {{x}} | Last-Mile Dashboard',
    transporter: 'Transporters | Last-Mile Dashboard',
    transporter_contract: 'Transporter Contracts | Last-Mile Dashboard',
    transporter_contracts: 'Transporter Contracts | Last-Mile Dashboard',
    transporter_drivers: 'Transporter Drivers | Last-Mile Dashboard',
    transporter_fleets: 'Transporter Fleets | Last-Mile Dashboard',
    transporter_pipeline: 'Transporter Pipelines | Last-Mile Dashboard',
    transporter_x_contracts: 'Transporter Contracts - {{x}} | Last-Mile Dashboard',
    transporter_x_drivers: 'Transporter Drivers - {{x}} | Last-Mile Dashboard',
    transporter_x_fleets: 'Transporter Fleets - {{x}} | Last-Mile Dashboard',
  },
};
